// light and dark themes should be handled here
// currently the below colors are for light theme

export const DEFAULT_COLORS = [
	// Gray
	{
		name: "Gray 100",
		value: "#F0F1F3",
		isBrightColor: false,
	},
	{
		name: "Gray 200",
		value: "#D5D8DC",
		isBrightColor: false,
	},
	{
		name: "Gray 300",
		value: "#B7BBC3",
		isBrightColor: false,
	},
	{
		name: "Gray 400",
		value: "#9FA4AD",
		isBrightColor: false,
	},
	{
		name: "Gray 500",
		value: "#848B95",
		isBrightColor: false,
	},
	{
		name: "Gray 600",
		value: "#717984",
		isBrightColor: false,
	},
	{
		name: "Gray 700",
		value: "#5E6773",
		isBrightColor: false,
	},
	{
		name: "Gray 800",
		value: "#4B545D",
		isBrightColor: false,
	},
	{
		name: "Gray 900",
		value: "#3A424B",
		isBrightColor: false,
	},
	{
		name: "Gray 1000",
		value: "#293038",
		isBrightColor: false,
	},
	// Blue
	{
		name: "Blue 100",
		value: "#EDF3FC",
		isBrightColor: false,
	},
	{
		name: "Blue 200",
		value: "#C6D8F6",
		isBrightColor: false,
	},
	{
		name: "Blue 300",
		value: "#92BEFC",
		isBrightColor: false,
	},
	{
		name: "Blue 400",
		value: "#6CA7EF",
		isBrightColor: false,
	},
	{
		name: "Blue 500",
		value: "#3A8EE9",
		isBrightColor: false,
	},
	{
		name: "Blue 600",
		value: "#0C79DF",
		isBrightColor: false,
	},
	{
		name: "Blue 700",
		value: "#0067B9",
		isBrightColor: false,
	},
	{
		name: "Blue 800",
		value: "#00549A",
		isBrightColor: false,
	},
	{
		name: "Blue 900",
		value: "#00427A",
		isBrightColor: false,
	},
	{
		name: "Blue 1000",
		value: "#00305B",
		isBrightColor: false,
	},
	// Purple
	{
		name: "Purple 100",
		value: "#F6EEFC",
		isBrightColor: false,
	},
	{
		name: "Purple 200",
		value: "#E5CEF6",
		isBrightColor: false,
	},
	{
		name: "Purple 300",
		value: "#D4ADF0",
		isBrightColor: false,
	},
	{
		name: "Purple 400",
		value: "#C48EEB",
		isBrightColor: false,
	},
	{
		name: "Purple 500",
		value: "#B16EE0",
		isBrightColor: false,
	},
	{
		name: "Purple 600",
		value: "#A451DF",
		isBrightColor: false,
	},
	{
		name: "Purple 700",
		value: "#8E3DC7",
		isBrightColor: false,
	},
	{
		name: "Purple 800",
		value: "#7531A5",
		isBrightColor: false,
	},
	{
		name: "Purple 900",
		value: "#5D2287",
		isBrightColor: false,
	},
	{
		name: "Purple 1000",
		value: "#431C5F",
		isBrightColor: false,
	},
	// Teal
	{
		name: "Teal 100",
		value: "#E3F5FC",
		isBrightColor: false,
	},
	{
		name: "Teal 200",
		value: "#A8DEF5",
		isBrightColor: false,
	},
	{
		name: "Teal 300",
		value: "#68C6EE",
		isBrightColor: false,
	},
	{
		name: "Teal 400",
		value: "#2CAFE8",
		isBrightColor: false,
	},
	{
		name: "Teal 500",
		value: "#1694CA",
		isBrightColor: false,
	},
	{
		name: "Teal 600",
		value: "#1981AE",
		isBrightColor: false,
	},
	{
		name: "Teal 700",
		value: "#0E6D95",
		isBrightColor: false,
	},
	{
		name: "Teal 800",
		value: "#07597E",
		isBrightColor: false,
	},
	{
		name: "Teal 900",
		value: "#034663",
		isBrightColor: false,
	},
	{
		name: "Teal 1000",
		value: "#053347",
		isBrightColor: false,
	},
	// Green
	{
		name: "Green 100",
		value: "#E4F6EF",
		isBrightColor: false,
	},
	{
		name: "Green 200",
		value: "#ABE3CD",
		isBrightColor: false,
	},
	{
		name: "Green 300",
		value: "#6FCEA6",
		isBrightColor: false,
	},
	{
		name: "Green 400",
		value: "#3DB885",
		isBrightColor: false,
	},
	{
		name: "Green 500",
		value: "#2E9E6F",
		isBrightColor: false,
	},
	{
		name: "Green 600",
		value: "#1F895E",
		isBrightColor: false,
	},
	{
		name: "Green 700",
		value: "#16744D",
		isBrightColor: false,
	},
	{
		name: "Green 800",
		value: "#115F3F",
		isBrightColor: false,
	},
	{
		name: "Green 900",
		value: "#114A32",
		isBrightColor: false,
	},
	{
		name: "Green 1000",
		value: "#0D3624",
		isBrightColor: false,
	},
	// Orange
	{
		name: "Orange 100",
		value: "#FEEFE7",
		isBrightColor: false,
	},
	{
		name: "Orange 200",
		value: "#FCCAB1",
		isBrightColor: false,
	},
	{
		name: "Orange 300",
		value: "#FEA77C",
		isBrightColor: false,
	},
	{
		name: "Orange 400",
		value: "#FB8246",
		isBrightColor: false,
	},
	{
		name: "Orange 500",
		value: "#E76423",
		isBrightColor: false,
	},
	{
		name: "Orange 600",
		value: "#CD5215",
		isBrightColor: false,
	},
	{
		name: "Orange 700",
		value: "#AE4410",
		isBrightColor: false,
	},
	{
		name: "Orange 800",
		value: "#91370B",
		isBrightColor: false,
	},
	{
		name: "Orange 900",
		value: "#702C0A",
		isBrightColor: false,
	},
	{
		name: "Orange 1000",
		value: "#551E03",
		isBrightColor: false,
	},
	// Red
	{
		name: "Red 100",
		value: "#FEEEEF",
		isBrightColor: false,
	},
	{
		name: "Red 200",
		value: "#FCCACE",
		isBrightColor: false,
	},
	{
		name: "Red 300",
		value: "#FFA3AB",
		isBrightColor: false,
	},
	{
		name: "Red 400",
		value: "#FE7B86",
		isBrightColor: false,
	},
	{
		name: "Red 500",
		value: "#F64C5A",
		isBrightColor: false,
	},
	{
		name: "Red 600",
		value: "#E13745",
		isBrightColor: false,
	},
	{
		name: "Red 700",
		value: "#C81A28",
		isBrightColor: false,
	},
	{
		name: "Red 800",
		value: "#A71420",
		isBrightColor: false,
	},
	{
		name: "Red 900",
		value: "#840D17",
		isBrightColor: false,
	},
	{
		name: "Red 1000",
		value: "#64060E",
		isBrightColor: false,
	},
];

export const DEFAULT_CUSTOM_COLORS = [
	{
		name: "White",
		value: "#FFF",
		isBrightColor: false,
	},
	{
		name: "Black",
		value: "#101820",
		isBrightColor: false,
	},
	{
		name: "Primary faint (Blue 200)",
		value: "#C6D8F6",
		isBrightColor: false,
	},
	{
		name: "Primary silent (Blue 100)",
		value: "#EDF3FC",
		isBrightColor: false,
	},
	{
		name: "Primary subtle (Blue 300)",
		value: "#92BEFC",
		isBrightColor: false,
	},
	{
		name: "Primary default (Blue 700)",
		value: "#0067b9",
		isBrightColor: false,
	},
	{
		name: "Primary strong (Blue 900)",
		value: "#00427A",
		isBrightColor: false,
	},
	{
		name: "Highlight silent (Purple 100)",
		value: "#F6EEFC",
		isBrightColor: false,
	},
	{
		name: "Highlight default (Purple 500)",
		value: "#B16EE0",
		isBrightColor: false,
	},
	{
		name: "Highlight strong (Purple 900)",
		value: "#8E3DC7",
		isBrightColor: false,
	},
	{
		name: "Success silent (Green 100)",
		value: "#E4F6EF",
		isBrightColor: false,
	},
	{
		name: "Success default (Green 500)",
		value: "#2E9E6F",
		isBrightColor: false,
	},
	{
		name: "Success strong (Green 900)",
		value: "#16744D",
		isBrightColor: false,
	},
	{
		name: "Warning silent (Orange 100)",
		value: "#FEEFE7",
		isBrightColor: false,
	},
	{
		name: "Warning default (Orange 500)",
		value: "#E76423",
		isBrightColor: false,
	},
	{
		name: "Warning strong (Orange 700)",
		value: "#AE4410",
		isBrightColor: false,
	},
	{
		name: "Danger silent (Red 100)",
		value: "#FEEEEF",
		isBrightColor: false,
	},
	{
		name: "Danger default (Red 700)",
		value: "#C81A28",
		isBrightColor: false,
	},
];
